import apiClient from './index';

const BASE_URL = '/adss/v1/faq';

// === FAQ Questions ===

export const getQuestions = async (skip = 0, limit = 10, roleId = null, search = null) => {
  try {
    const params = { skip, limit };
    if (roleId !== null) {
      params.role_id = roleId;
    }
    if (search !== null && search.trim() !== '') {
      params.search = search.trim();
    }
    
    const response = await apiClient.get(`${BASE_URL}/questions`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching FAQ questions:', error);
    throw error;
  }
};

export const getQuestion = async (questionId) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/questions/${questionId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching FAQ question:', error);
    throw error;
  }
};

export const createQuestion = async (questionData) => {
  try {
    const response = await apiClient.post(`${BASE_URL}/questions`, questionData);
    return response.data;
  } catch (error) {
    console.error('Error creating FAQ question:', error);
    throw error;
  }
};

export const updateQuestion = async (questionId, questionData) => {
  try {
    const response = await apiClient.put(`${BASE_URL}/questions/${questionId}`, questionData);
    return response.data;
  } catch (error) {
    console.error('Error updating FAQ question:', error);
    throw error;
  }
};

export const deleteQuestion = async (questionId) => {
  try {
    const response = await apiClient.delete(`${BASE_URL}/questions/${questionId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting FAQ question:', error);
    throw error;
  }
};

// === FAQ Answers ===

export const createAnswer = async (questionId, answerData) => {
  try {
    const response = await apiClient.post(`${BASE_URL}/questions/${questionId}/answers`, answerData);
    return response.data;
  } catch (error) {
    console.error('Error creating FAQ answer:', error);
    throw error;
  }
};

export const updateAnswer = async (answerId, answerData) => {
  try {
    const response = await apiClient.put(`${BASE_URL}/answers/${answerId}`, answerData);
    return response.data;
  } catch (error) {
    console.error('Error updating FAQ answer:', error);
    throw error;
  }
};

export const deleteAnswer = async (answerId) => {
  try {
    const response = await apiClient.delete(`${BASE_URL}/answers/${answerId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting FAQ answer:', error);
    throw error;
  }
};

export const acceptAnswer = async (answerId) => {
  try {
    const response = await apiClient.put(`${BASE_URL}/answers/${answerId}/accept`);
    return response.data;
  } catch (error) {
    console.error('Error accepting FAQ answer:', error);
    throw error;
  }
};